import { LocationOnOutlined, RouteOutlined } from "@mui/icons-material";

export const ROUTE_POLICY_TYPES = {
  kmRate: "kmRate",
  fixedRoute: "fixedRoute",
};

export const ROUTE_POLICY_TYPE_LABELS = {
  [ROUTE_POLICY_TYPES.kmRate]: "Taxa por KM",
  [ROUTE_POLICY_TYPES.fixedRoute]: "Rota fixa",
};

export const ROUTE_POLICY_TYPE_SHORT_LABELS = {
  [ROUTE_POLICY_TYPES.kmRate]: "por km",
  [ROUTE_POLICY_TYPES.fixedRoute]: "valor fixo",
};

export const ROUTE_POLICY_TYPE_DESCRIPTIONS = {
  [ROUTE_POLICY_TYPES.kmRate]:
    "Define um valor cobrado por km percorrido pelo colaborador.",
  [ROUTE_POLICY_TYPES.fixedRoute]:
    "Define dois pontos fixos e um valor único para o trajeto, independente da distância.",
};

export const ROUTE_POLICY_TYPE_ICONS = {
  [ROUTE_POLICY_TYPES.kmRate]: LocationOnOutlined,
  [ROUTE_POLICY_TYPES.fixedRoute]: RouteOutlined,
};

/**
 * Discriminador: uma política é Rota Fixa quando contém o objeto
 * `preDefinedRoute`. Caso contrário é Taxa por KM (default).
 */
export const isFixedRoutePolicy = (policy) =>
  Boolean(policy?.preDefinedRoute);

export const getPolicyType = (policy) =>
  isFixedRoutePolicy(policy)
    ? ROUTE_POLICY_TYPES.fixedRoute
    : ROUTE_POLICY_TYPES.kmRate;

/**
 * Retorna o valor monetário "atual" da política:
 * - Rota Fixa: usa `preDefinedRoute.amount` (fallback para `currentRate` se
 *   ainda não tiver amount — políticas legadas).
 * - Taxa por KM: usa `currentRate`.
 */
export const getPolicyCurrentValue = (policy) => {
  if (!policy) return 0;
  if (isFixedRoutePolicy(policy)) {
    const amount = policy?.preDefinedRoute?.amount;
    if (amount !== null && amount !== undefined) {
      return Number(amount) || 0;
    }
    return Number(policy?.currentRate) || 0;
  }
  return Number(policy?.currentRate) || 0;
};
